import { useMutation } from "@tanstack/react-query";
import {
  postAuthSendPhoneVerification,
  type SendPhoneVerificationRequest,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useSendPhoneVerificationMutation = ({
  onSuccess,
  onError,
}: Props = {}) =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (request: SendPhoneVerificationRequest) =>
        postAuthSendPhoneVerification(request),
    ),
    onSuccess,
    onError,
  });
